const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCookedfood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cookedfood") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "transparent_squares",
    "data-name": "transparent squares"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.05,
    y: -0.05,
    width: 1000,
    height: 1000,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "cooked-food"
  }, /*#__PURE__*/React.createElement("g", {
    id: "steak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M584.1,700.64c-90.94-14.23-176.57-44.87-181.54-78.12h-.2v-2c0-.67,0-1.34,0-2V542.81c.5,8,5.7,15.85,14.59,23.39C423.34,629.63,491.66,682.42,584.1,700.64Z",
    style: {
      fill: "#966940"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902,526.5V604c0,.39,0,.78,0,1.16v.63h0a16,16,0,0,1-2.31,7.72c-5,8-15.87,7.66-29.32,8.56-10.43.72-22.41,2.16-34.4,8.77C813,643.5,806.44,666,800.12,676.49l-.16.27c-16.55,27.1-77.79,35.31-147.42,31.3q-7-.4-14.15-1c-17.91-1.42-36.21-3.6-54.29-6.44-92.44-18.22-160.76-71-167.15-134.44-8.89-7.54-14.09-15.4-14.59-23.39V539h76.77a310.79,310.79,0,0,1,46.39-18.9h0c7.2-2.34,13.93-4.36,20-6.16a351,351,0,0,1,97.35-14.52c12.9-.13,25.55.41,37.91,1.51a421.58,421.58,0,0,1,43.62,6.24c12,2.35,23.59,5.15,34.71,8.25,2,.55,4,1.12,5.93,1.69h0c7.4,2.16,14.61,4.47,21.55,6.86,2.63.89,5.22,1.81,7.77,2.73h0q11.88,4.29,22.72,8.8v-9Z",
    style: {
      fill: "#a67c52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.82,526.5a21,21,0,0,1-2.17,9.11,13.46,13.46,0,0,1-6.76,6.13c-12.29,5.43-35.15-.83-57,11.19-23.1,12.76-29.6,35.48-36,45.91-14,23-60.2,32.37-116.37,32.26h0c-1.53,0-3.07,0-4.62,0l-4.1-.06-2.94-.07-3.16-.08-4.09-.14c-1.53-.05-3.06-.12-4.6-.19l-4.81-.23-4.83-.28-4.86-.32a728.25,728.25,0,0,1-88.92-11.8q-10.25-2-20.21-4.26-6-1.35-11.81-2.79c-26.55-6.55-50.93-14.42-70.82-23.14q-2.7-1.19-5.3-2.4c-2.31-1.08-4.55-2.16-6.71-3.26s-4.26-2.21-6.27-3.33c-1-.56-2-1.13-3-1.69l-1.43-.85c-.95-.57-1.88-1.14-2.78-1.71A102.51,102.51,0,0,1,417,566.2c-8.89-7.54-14.09-15.4-14.59-23.39a21.52,21.52,0,0,1,0-2.54c0-.42.07-.82.13-1.24a22.67,22.67,0,0,1,2.47-7.7c5.92-11.3,16.85-22.66,30.12-33.42,39.58-32.06,100-58.69,110.42-61.87a339.57,339.57,0,0,1,40-9.61h0q4.28-.76,8.52-1.42c.94-.15,1.88-.29,2.83-.42q4.23-.61,8.45-1.11c3.75-.45,7.47-.83,11.19-1.15,1.85-.16,3.7-.3,5.55-.43,2.76-.19,5.52-.35,8.26-.48h0a383,383,0,0,1,88.59,6.38q10.29,1.92,20.16,4.28,5.91,1.41,11.67,2.95h0a479.63,479.63,0,0,1,73.5,26.32c8.93,4,17.17,8,24.59,11.9l1.48.76q5.63,2.92,10.6,5.68c12.16,6.73,21.37,12.5,27.15,16.19a36.32,36.32,0,0,1,8.36,9.74,41.67,41.67,0,0,1,3.94,9.47A37.06,37.06,0,0,1,901.82,526.5Z",
    style: {
      fill: "#8c6239"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.29,421.42a344.92,344.92,0,0,0-44.82,5L465.94,539l-37.6,35.43a193.4,193.4,0,0,0,25.46,13.25l71.68-67.54Z",
    style: {
      fill: "#603813"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.72,435c-10.24-2.73-20.86-5.18-31.84-7.22l-76.06,71.65L524.62,610.84c10.38,2.56,21.09,4.92,32,7L680.73,501Z",
    style: {
      fill: "#603813"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.23,461.36,765,517.15,645.55,629.69c13,.91,25.75,1.38,38,1.41h0L794.35,526.74,850.29,474C842.49,470,833.76,465.64,824.23,461.36Z",
    style: {
      fill: "#603813"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.58,523.42l13.29,13.93c6.49,6.8,18.66,1.3,22.52-7.4a13.11,13.11,0,0,0,1-7.89l-3.6-18.46-.3-1.56a9.8,9.8,0,0,0-.56-1.88c-2.49-6.16-10.53-7.84-17.65-3.21l-9.37,6.1C721.09,508.12,718.49,518.1,723.58,523.42Z",
    style: {
      fill: "#ddd1c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.4,474l-25.27-1.57c-12.33-.77-18.38,3.7-13.78,7.39a17.35,17.35,0,0,0,6.48,2.77l20.59,5.2,1.75.44c.75.19,1.51.35,2.28.49,8,1.45,17,.21,19.23-2.87l2.92-4.06C733,478.44,726.07,474.63,716.4,474Z",
    style: {
      fill: "#ddd1c2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "egg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.51,774.18c-21.69-.19-24.09-.21-31.62-.21-42.23,0-82.44,1-118.95,2.94-4.87.26-8,0-12.92.25-1.28.05-2.52.11-3.74.18a181.64,181.64,0,0,0-36.86,5.5c-16.41,4.23-27.28,9.32-49.08,10.19-22.12.9-29.75-3.59-51,1.66A119.09,119.09,0,0,0,168,803.58a139.07,139.07,0,0,0-14.85,6.92c-9.88,5.4-26.8,20.18-23.85,28.13,4.74,12.76,58.48,1,61.26,11.57,1.26,4.85-9.49,9.36-8.17,13.62,1.82,5.89,23.52,1,45.31,1a11.19,11.19,0,0,0-.39,2.36c-.95,19.75,55.5,36.55,58.53,37.43a128.07,128.07,0,0,0,27.82,4.88c44,3.26,61.77-12,103.88-18.49,55.94-8.55,91.38,8.23,99.72-8.17,3.33-6.56.47-14.8-2.5-20.76a94.81,94.81,0,0,1,11.72-3.67s3.51-.85,7.11-1.43c18.08-2.91,103.12,4.08,103.12,4.08,38.44,3.17,84.46-1.88,86.09-12.25.57-3.59-3.89-9.74-30.05-20.54,34.79-3.31,74.79-8.77,75.13-17.34.19-4.88-12.52-9.18-23.64-12.48C666.28,775.27,580.08,774.89,496.51,774.18Zm-130,47.44c-78.56,0-142.25-6.7-142.25-15,0-5.18,25-9.74,62.89-12.42a38.86,38.86,0,0,0-1.64,11.14c0,.45,0,.89,0,1.34,28,8.21,61.78,13.52,98.56,14.79C378.37,821.58,372.5,821.62,366.54,821.62Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.77,818.89a475.37,475.37,0,0,1-53.21,2.92q-8.82,0-17.44-.32c-36.78-1.27-70.58-6.58-98.56-14.79,0-.45,0-.89,0-1.34a38.86,38.86,0,0,1,1.64-11.14,44.4,44.4,0,0,1,5.24-11.38c10-15.85,30.33-28.8,56.22-36.13-11.52,10-18.9,20.91-19.36,30.63a18.35,18.35,0,0,0,.22,4,22,22,0,0,0,5.29,10.7C349.11,809,389.47,820,433,819.89,440.19,819.87,447.49,819.55,454.77,818.89Z",
    style: {
      fill: "#f7931e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.15,805.36c0,.6,0,1.21,0,1.8s-.07,1.1-.11,1.66c-10.3,2.72-21.31,5.08-32.89,7-.37.08-.76.15-1.15.21-6.85,1.11-13.92,2.08-21.15,2.87h0c-59.9,5.37-121-11.56-125.28-37.55-1.75-10.65,6-23.26,19.14-34.63a181.13,181.13,0,0,1,49.21-6.58C459.86,740.13,510.15,769.33,510.15,805.36Z",
    style: {
      fill: "#fbb03b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.12,821.49c-5.75.09-11.62.13-17.58.13-78.56,0-142.25-6.7-142.25-15,0-5.18,25-9.74,62.89-12.42a38.86,38.86,0,0,0-1.64,11.14c0,.45,0,.89,0,1.34C313.54,814.91,347.34,820.22,384.12,821.49Z",
    style: {
      fill: "#b3b3b3",
      fillOpacity: 0.51
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "kala"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.12,101.89h.2l-.26,0h0c-.56.32-1.1.66-1.64,1C547.18,141,504,202.64,491.13,270.59l.05,0c.15.14.08.35-.17.68A225.71,225.71,0,0,0,494.15,369l.15.12a1.56,1.56,0,0,1,.26.24l.34.31A12.12,12.12,0,0,1,498.56,381s0,.09,0,.13a.34.34,0,0,1-.12-.06l-1-.5h0a1.12,1.12,0,0,0-.22-.1h0a121.89,121.89,0,0,0-13.63-5.9l0,0a122.16,122.16,0,0,0-16.47-4.67c-1.27-.25-2.54-.52-3.8-.72h-.09a119.3,119.3,0,0,0-13.85-1.57,129.47,129.47,0,0,0-28.72,1.75,0,0,0,0,0,0,0,150.68,150.68,0,0,0-18.49,4.42c-1.72.53-3.45,1.09-5.17,1.69h0q-4.08,1.38-8.14,3c-4.67,1.88-9.35,4-14,6.32-.18.09-.35.17-.52.27-3,1.47-5.92,3-8.88,4.72-2.07,1.17-4.12,2.37-6.19,3.62l-.33.21h0q-5.34,3.27-10.67,6.92-9.06,6.22-18,13.55h0q-11.66,9.54-23,20.82h0c-3.67,3.67-7.3,7.45-10.88,11.38-.58.62-1.16,1.25-1.72,1.87-2.28,2.51-4.55,5.1-6.78,7.71q-5,5.82-9.86,12-4.53,5.72-9,11.72c-1,1.33-2,2.67-2.94,4-.24.32-.5.66-.73,1l-.56.79s0,0,0,0a.35.35,0,0,1-.07.09h0c-2.58,3.67-5.12,7.33-7.64,11.1Q248.8,508.83,241.1,522v0s0,0,0,0l0-.09-1.23-4.19-5.59-19.16s0,0,0,0,0,0,0,0l-5.68-19.44-.15-.52-.88-3c0-.3,0-.61,0-.93v0c.1-2.67.25-6.52.59-11.38.06-.91.12-1.85.19-2.84h0c.24-3.32.56-7,1-11.07h0q.64-6.68,1.67-14.54l5.39-32.37.41-2.46q1-4.82,2.1-9.8c.24-1.07.49-2.14.73-3.21q1-4.25,2.07-8.62c1.48-5.85,3.11-11.86,4.89-18v0c.78-2.65,1.59-5.31,2.44-8q2.37-7.53,5.09-15.28s0,0,0,0a422.65,422.65,0,0,1,19.64-46.74q2-4.05,4.13-8.1s0,0,0,0a2.84,2.84,0,0,1,.24-.45c3.53-6.76,7.33-13.54,11.41-20.26,1.43-2.38,2.89-4.73,4.39-7.11h0c1.25-2,2.53-3.95,3.84-5.92l.37-.56c2.79-4.18,5.69-8.35,8.71-12.46a333.24,333.24,0,0,1,37.6-43.29h0q3.19-3.08,6.49-6.1h0a322.16,322.16,0,0,1,29-23.63,437,437,0,0,1,40.31-26.28s0,0,0,0a1.13,1.13,0,0,1,.21-.12c2.3-1.31,4.66-2.65,7.1-4q2.32-1.28,4.72-2.55c3.93-2.06,8-4.13,12.2-6.17h0c1.13-.55,2.28-1.09,3.43-1.63,2.82-1.33,5.72-2.64,8.67-3.92a305.82,305.82,0,0,1,42.79-15.14h0a245.56,245.56,0,0,1,36.4-7,209.93,209.93,0,0,1,27-1.33A186.89,186.89,0,0,1,606.06,100c1.43.36,2.84.74,4.27,1.14.68.18,1.37.38,2.06.59l-.21.13Z",
    style: {
      fill: "#a67c52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.15,201.91l.47.79v0C734.46,202.42,734.3,202.17,734.15,201.91Z",
    style: {
      fill: "#a67c52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.74,564.47c1.58,1.4,3.25,2.82,3.91,2.51,23.07-10.8,41.74-19.55,60.81-28.61,0,0,40.34-19.15,66.79-20.39,2.75-.13,5.56-.2,5.56-.2h0a2.76,2.76,0,0,0,2.67-2.72c.13-10.4.32-10,.45-21.54a2.7,2.7,0,0,0-.67-1.82l-1.09-1.29c-2.71-3.24-7.35-9-13.66-15.74h0c-3-3.17-6.33-6.54-10-10h0A143.08,143.08,0,0,0,206,455c-6.93-5.28-29.7-22.61-45.25-22.78C120.9,431.78,79.27,543.61,102.74,564.47Z",
    style: {
      fill: "#996e47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.57,512.19c1-5.53-.15-10.42,1-16a7.06,7.06,0,0,1,4.75-5.21c13.06-4.22,53.46-14.66,84.69,5.47a84.91,84.91,0,0,1,21.49,20.07,7.08,7.08,0,0,1,.9,7.05L317.9,591.34a7.07,7.07,0,0,1-12.81.51,181.66,181.66,0,0,0-27.61-39.61,174.81,174.81,0,0,0-40.54-32.73A7,7,0,0,1,233.57,512.19Z",
    style: {
      fill: "#996e47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491,271.3c0-.23.08-.47.12-.71l.05,0C491.33,270.76,491.26,271,491,271.3Z",
    style: {
      fill: "#996e47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.32,101.89l-.26,0s0,0,.06,0Z",
    style: {
      fill: "#996e47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.62,202.7,736,205c-.45-.77-.9-1.52-1.36-2.28Z",
    style: {
      fill: "#996e47"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.32,101.89l-.26,0H612c-.69.1-2.35.34-4.81.72-10.86,1.66-37.09,6-62.5,12.46a279,279,0,0,0-33.49,10.44h0c-14.75,5.85-25.41,12.65-26.5,20.2-3.71,25.67,38.39,45.71,35.52,46.75-3,1.11-75.44-30.52-57-55.45a35.41,35.41,0,0,1,2.72-3.22,45.73,45.73,0,0,1,6-5.18h0s0,0,0,0c.25-.19.5-.37.76-.54s.76-.53,1.14-.77q2-1.34,4.19-2.55c16.22-9,40.19-14.52,63.39-17.84a556.88,556.88,0,0,1,65.44-5c2.77,0,4.57-.06,5.21-.06,0,0,0,0,0,0Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.1,271.46c-3.06,1.11-69.54-18-66.78-48.92,3-33,95.29-31.17,97.51-29.23,2,1.79-66.94,1.34-70.8,28.09C445.33,247.08,492,270.42,489.1,271.46Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.46,262.63c-.21,1.9-51.15,8-67.1-18.5a22.44,22.44,0,0,1-3.83-11.57c-.4-29.32,68.94-41.94,71.74-40.54a.1.1,0,0,1,.06,0c.56,1.41-51.57,14-53.9,35-.66,5.92,2.85,10.68,6,15C353.81,263,385.63,261.13,385.46,262.63Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.1,303.29c5.54-.66,10.37-1.57,13.29-2l-1,2.46a139.7,139.7,0,0,1-16.94,7.5c-12.09,4.43-26.89,8.08-37.11,5.26a17.4,17.4,0,0,1-5.9-2.8c-.28-.2-.57-.44-.84-.66a15.42,15.42,0,0,1-1.88-2,14.61,14.61,0,0,1-1.48-3.09,29,29,0,0,1-1.54-5.54,23.82,23.82,0,0,1-.32-6.58,23.45,23.45,0,0,1,1.29-5.55,38.28,38.28,0,0,1,4.13-8.1s0,0,0,0c11.7-18,38.16-34.68,40.62-37.73l.05-.06c.28-.33,1.59-1.76,2.82-1.83.38,0-.53,1-2.22,2.78l-.26.27c-7.81,8.19-30.69,31-28.89,45.54a10.8,10.8,0,0,0,1.69,4.68,1.53,1.53,0,0,0,.11.16C297.92,305,313.76,304.76,326.1,303.29Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.89,370.7c.14.16.27.31.41.45s.25.26.38.38a12.26,12.26,0,0,0,2.57,1.91,16.49,16.49,0,0,0,7.93,1.82,27.59,27.59,0,0,0,4.84-.41c.27,0,.53-.08.8-.12a49.45,49.45,0,0,0,7.19-1.92c12-4,26.19-12.45,39-21.38,4.62-3.23,9.07-6.51,13.18-9.66l0,0h0c2.39-1.83,4.66-3.64,6.78-5.35,1.55-1.24,3-2.45,4.38-3.59a13.59,13.59,0,0,1-3.13-.18,12.23,12.23,0,0,1-2.81-.83c-.21.12-.4.25-.62.37-2.9,1.75-6,3.62-9.3,5.52-4.21,2.45-8.65,4.94-13.13,7.34-10.15,5.41-20.54,10.2-29,12.42a37.69,37.69,0,0,1-5.62,1.12,20.84,20.84,0,0,1-6,0h0a9.12,9.12,0,0,1-4.53-2c-.17-.15-.32-.3-.47-.46-7.28-7.5,1.4-30.36,9.57-48.12.79-1.75,1.59-3.44,2.36-5.07,1.93-4,3.71-7.64,5.16-10.54h0A52,52,0,0,0,285,285.3c0-.13,0-.21,0-.22s-.12,0-.22.1c-.93.72-4.18,5-8.39,11.46-.86,1.33-1.79,2.74-2.71,4.24l-1,1.55C261.18,321,246.13,350,249.24,365A12.46,12.46,0,0,0,251.89,370.7Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.67,405.2h0a6.1,6.1,0,0,0,.41.7h0a10.44,10.44,0,0,0,3.26,3.32l.48.3c11,6.12,34.27-12.7,48.46-26.43h0l1.9-1.85,1.6-1.6c5.24-5.3,8.54-9.23,8.32-9.55s-4.41,3.19-10.38,7.83c-12.81,10-33.84,25.07-41.6,18.3a7.23,7.23,0,0,1-1.53-1.91,10.29,10.29,0,0,1-.78-1.74c-.08-.19-.14-.39-.21-.6a21,21,0,0,1-.68-3.57c-1.08-10.36,3.33-27.49,7.87-42.14,2.93-9.42,5.9-17.81,7.5-22.75-.32-.59-.62-1.18-.88-1.79-1.6,2.67-4,7.1-6.69,12.59v0c-.79,1.61-1.6,3.31-2.44,5.07-.58,1.24-1.17,2.52-1.76,3.84-8.61,19-17.76,44.54-14.27,58.26A14.67,14.67,0,0,0,314.67,405.2Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.41,422.55a10.29,10.29,0,0,0,1.85,1.62l.33.19c.05,0,.11.06.17.1a9.11,9.11,0,0,0,2.73,1.05c11.11,2.4,31-12,45.23-24.27h0l1.23-1.06a1.1,1.1,0,0,1,.16-.15c2.75-2.41,5.22-4.69,7.35-6.74,1.08-1,2.07-2,3-2.9a8.46,8.46,0,0,1-.77-1.66c-.19.16-.4.3-.61.45-1.48,1.13-3.22,2.4-5.09,3.79-1.39,1-2.87,2.08-4.42,3.18l-2.19,1.55C297,407,280,417,273.25,411.6c-6.18-5-2.55-22.09,2.76-38.79.4-1.25.81-2.5,1.23-3.74.89-2.7,1.83-5.35,2.75-7.9.28-.78.57-1.57.85-2.33.18-.47.34-.94.51-1.41a37.69,37.69,0,0,1-5.62,1.12c-.78,1.51-1.55,3.06-2.33,4.65-.65,1.31-1.29,2.66-1.94,4-.12.26-.25.53-.36.78h0c-.31.67-.62,1.34-.92,2-.73,1.58-1.45,3.2-2.14,4.81-.21.47-.4.93-.61,1.4C259.54,394.85,254.15,414.57,261.41,422.55Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.59,448.18l1.72-1.88c3.58-3.92,7.22-7.71,10.88-11.37h0c1.81-9.26,5.32-20.06,8.75-29.58,1.58-4.38,3.14-8.49,4.51-12.07.56-1.46,1.09-2.84,1.58-4.1.13-.36.26-.71.4-1l-.63-3.46c-1.33,2.13-3,4.93-4.86,8.27h0c-1.21,2.15-2.5,4.52-3.82,7.06-.33.62-.67,1.25-1,1.89h0C304.91,415.9,296.9,434.06,294.59,448.18Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.33,402.44c5.11-3,14-9,26.22-21.2h0l.67-.67c1.51-1.51,2.91-3,4.18-4.3h0c.49-.53,1-1,1.4-1.52h0l2-2.31c2.58-3,4-5,3.88-5.35s-1.35.53-3.34,2c-.37.28-.8.58-1.23.91v0c-1.64,1.21-3.64,2.74-5.9,4.41l-1.08.81c-.84.63-1.72,1.26-2.63,1.92-6.47,4.64-14.34,9.81-21.72,13-.74,3.32-1.44,6.6-2.09,9.8Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.27,449.36c-.39,4.05-.71,7.75-1,11.06,12.47-7.95,26.78-25.15,34.94-36.26l.61-.83h0c1.36-1.87,2.53-3.55,3.47-4.95,1.75-2.62,2.68-4.29,2.52-4.44s-.94.66-2.28,2.05c-.63.66-1.38,1.45-2.23,2.36l-3.95,4.21c-8.61,9.08-22.05,22.64-32.14,26.8Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.45,240.6c.07.23-1.87,1.42-5.19,3.14a.39.39,0,0,1-.11.06,234.5,234.5,0,0,1-24.26,10.55c1.25-2,2.53-3.95,3.84-5.92,7.59-2.06,14.75-4.48,19.58-6.09l.64-.21C321.3,241,323.37,240.35,323.45,240.6Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.73,485.19c-.25-.5-.47-1-.69-1.59-4.78-12.84-1.56-41.36.45-58.09.34-2.74.63-5.16.86-7.14l.24-2.39c.22-2.17.25-3.41,0-3.44a.07.07,0,0,0-.06,0c-.3.26-1.11,2.36-2.19,5.76-.45,1.44-1,3.12-1.48,5h0c-.1.33-.19.68-.29,1-4.46,15.86-10.69,44.16-8.74,62.64Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.29,332.82a23.41,23.41,0,0,0,3.2,4.81,25.66,25.66,0,0,0,2.07,2.1c.36.31.72.63,1.1.93a26.89,26.89,0,0,0,4.4,2.84c17.06,8.93,45.31,3.37,56-.08,2.47-.79,4-1.48,4.26-1.84s-.37-.49-1.5-.67c-7.46-1.2-40.17-1.61-50.38-19.72a16.39,16.39,0,0,1-.88-1.72,2,2,0,0,1-.14-.3c-2.17-4.91-1.85-10.17,0-15.44.29-.82.61-1.65,1-2.47,5.2-11.92,17.5-23.6,26-31,3-2.6,5.46-4.69,7-6.08,1.34-1.19,2-1.87,1.68-1.94s-1.85.64-4.15,2c-1.29.76-2.81,1.72-4.54,2.85h0c-10.8,7.12-28.94,21.21-39.3,36.23a57.58,57.58,0,0,0-4.63,7.93C318,318.69,317,326.12,320.29,332.82Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,194.64c0,.05,0,.09-.08.11a2.3,2.3,0,0,1-.48.08c-.48,0-1.26.08-2.32.1h-.64c-.51,0-1.06,0-1.67,0-1.64,0-3.61-.08-5.82-.19a209.2,209.2,0,0,1-24.58-2.61q3.19-3.08,6.49-6.1h0c7.75,3.3,17.21,5.59,23.19,7l1.22.29h0l1,.23c.92.24,1.69.42,2.29.59A4,4,0,0,1,380,194.64Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.48,123.27a181.7,181.7,0,0,0,29.38,4.08c3.1.19,5.87.31,8.14.35l.44,0,.06,0c.59,0,1.13,0,1.63,0a20.29,20.29,0,0,0,3.87-.18c.54-.21-1.63-.73-5.24-1.58-1.38-.33-3-.71-4.71-1.16-6.48-1.6-14.89-4-21.46-7.08q-4.43,1.94-8.68,3.92Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.33,223.82c-2.78,2-71.72-4.64-75-40.65-3.54-38.52,96.83-56.79,99.39-55.07,2.36,1.57-74.83,16.09-73.41,47.62C400.65,206,450.94,222,448.33,223.82Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.77,378.28v0a15.34,15.34,0,0,0,.66,1.57,18,18,0,0,0,3.82,5.19l.51-.26c4.65-2.33,9.33-4.45,14-6.32q4.07-1.64,8.14-3a20.55,20.55,0,0,1-7.12-8.53c-6.19-14.48,14.82-33.1,28.7-43.94,2-1.57,3.83-3,5.43-4.16L425,318c3.27-2.45,5.21-3.92,4.71-4s-2.06.69-4.67,2.1c-.79.42-1.65.91-2.59,1.46-1.92,1.09-4.15,2.43-6.58,4a208.63,208.63,0,0,0-26,19.38c-.94.82-1.85,1.67-2.76,2.51-10.32,9.69-18.39,20.43-18.2,30a14.77,14.77,0,0,0,.19,2.11c.05.38.12.74.2,1.11A11.8,11.8,0,0,0,369.77,378.28Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491,271.3c-3.24,4-36.83,22.46-40.4,47.26-2.22,15.37,16.16,34.16,30.68,47,.09.07.17.16.25.23,7,6.22,13.11,11,15.42,13.3a7,7,0,0,1,.55.57c.44.5.57.79.34.87a1.1,1.1,0,0,1-.42,0h0l-.2,0h0c-1.84-.36-6.94-2.47-13.63-5.9l0,0c-3.86-2-8.25-4.38-12.86-7.13h0l-.16-.09c-16.92-10.13-36.6-24.86-43.2-39.81a26.52,26.52,0,0,1-2.17-7.67A14.68,14.68,0,0,1,425,318c0-.63,0-1.27,0-1.9l0-.28C427.51,288.35,470,274,485.58,271h0c1.17-.23,2.17-.39,3-.49a5.62,5.62,0,0,1,2.52,0l.05,0C491.33,270.76,491.26,271,491,271.3Z",
    style: {
      fill: "#cadbe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.19,331.79c-3.05,1.11-75.55-33.85-72.79-64.73,3-33,63.89-47.14,66.11-45.2,2.05,1.79-36.7,21.2-40.57,47.95C387.24,295.48,441.05,330.75,438.19,331.79Z",
    style: {
      fill: "#cadbe5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M494.3,369.13l-.15-.12C494.09,368.82,494.17,369,494.3,369.13Z",
    style: {
      fill: "#996e47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.9,369.68c-.16.07-.4-.26-.58-.51l.24.2Z",
    style: {
      fill: "#996e47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.87,105.06c33.86,110.37-17,226.25-115.31,276-.82-2-1.45-3.6-1.86-4.71-1.33-3.56-2.54-7.33-2.55-7.32h0A225.71,225.71,0,0,1,491,271.3c.25-.33.32-.54.17-.68l-.05,0c12.88-67.95,56-129.6,119.28-167.67.54-.33,1.08-.67,1.64-1h0l.26,0h-.2l.06,0,.6-.25C613.14,102.75,613.51,103.9,613.87,105.06Z",
    style: {
      fill: "#ffb1a2"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.07,
    cy: 245.6,
    rx: 34.18,
    ry: 14.04,
    transform: "translate(153.78 702.01) rotate(-72.22)",
    style: {
      fill: "#ddd1c2"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 525.81,
    cy: 323.75,
    rx: 62.57,
    ry: 2.37,
    transform: "translate(6.92 658.48) rotate(-64.45)",
    style: {
      fill: "#ddd1c2"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookedfood);
export default __webpack_public_path__ + "static/media/cookedfood.8681db035a09bb41b57280841fd3451a.svg";
export { ForwardRef as ReactComponent };